// extracted by mini-css-extract-plugin
export default {"fullHeight":"AdminSettings_fullHeight__qrXyv","partnersSibling":"AdminSettings_partnersSibling__3Eb9o"};